var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-container" }, [
      _c("div", { staticClass: "helloWard" }, [_vm._v("欢迎使用省平台")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }